import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "showIcon", "hideIcon"]

  toggle(event) {
    event.preventDefault()
    const field = this.fieldTarget
    const showing = field.type === "text"
    field.type = showing ? "password" : "text"

    if (this.hasShowIconTarget) this.showIconTarget.classList.toggle("hidden", !showing)
    if (this.hasHideIconTarget) this.hideIconTarget.classList.toggle("hidden", showing)
  }
}
